'use es6';

import { useSelector } from 'react-redux';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import PreRenderedRichTextElement from 'LayoutBuilderUI/components/placeholders/PreRenderedRichTextElement';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const makeAsyncRichText = loader => {
  return Loadable({
    delay: 0,
    loader,
    LoadingComponent: PreRenderedRichTextElement,
    ErrorComponent: PreRenderedRichTextElement
  });
};
const AsyncRichTextWithDndConfig = makeAsyncRichText(() => import( /* webpackChunkName: 'rich-text-with-dnd-config' */'LayoutBuilderUI/components/fields/overrides/RichTextWithDndConfig'));
const AsyncRichTextWithStaticConfig = makeAsyncRichText(() => import( /* webpackChunkName: 'rich-text-with-static-config' */'LayoutBuilderUI/components/fields/overrides/RichTextWithStaticConfig'));
function AsyncRichTextWithConfig(props) {
  const AsyncRichText = useSelector(getIsCustomEmail) ? AsyncRichTextWithStaticConfig : AsyncRichTextWithDndConfig;
  return /*#__PURE__*/_jsx(AsyncRichText, Object.assign({}, props));
}
export default AsyncRichTextWithConfig;